exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section {\n  margin: 40px; }\n\n.sub-section {\n  margin: 40px; }\n\n.ng-valid[required], .ng-valid.required {\n  border: 1px solid #42A948;\n  /* green */ }\n\ntextarea.ng-invalid:not(form) {\n  border: 1px solid #a94442;\n  /* red */ }\n\n.required {\n  color: #a94442; }\n\nss-multiselect-dropdown > li.active > a > span {\n  background-color: #fff; }\n\ntable.documentacion tr {\n  line-height: 25px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/expedientes/evaluacion/evaluacion.component.scss
// module id = ../../../../../src/app/modules/expedientes/evaluacion/evaluacion.component.scss
// module chunks = main